import React from 'react';
import { Link } from 'react-router-dom';
import { WINE_TYPES } from '../data/wines';
import { useWines } from '../context/WinesContext';
import { useT } from '../i18n/LanguageContext';
import { TYPE_KEYS, TYPE_DESC_KEYS } from '../i18n/translations';
import fotoVinhosHero from '../assets/douronostrum_fotos1_00000072.jpg';

/* ============================================================
   Página Vinhos — apresentação das categorias
   (O overlay mostra o mesmo conteúdo no hover; esta página
    serve como fallback quando o link é clicado ou em mobile.)
   ============================================================ */

export default function Vinhos() {
  const t = useT();
  const { wines, loading, error, refetch } = useWines();
  return (
    <div className="page-top">
      <section
        className="section"
        style={{
          background: `linear-gradient(160deg, rgba(14,7,4,0.65) 0%, rgba(14,7,4,0.35) 100%), url(${fotoVinhosHero}) center/cover no-repeat`,
          paddingTop: 'calc(var(--nav-height) + var(--sp-16))',
        }}
      >
        <div className="container">
          <p className="t-label" style={{ color: '#ffffff', marginBottom: 'var(--sp-4)' }}>
            {t('vinhos.eyebrow')}
          </p>
          <h1 className="t-h1" style={{ color: '#ffffff' }}>
            {t('vinhos.title')}
          </h1>
          <p className="t-body-lg" style={{ color: 'rgba(255,255,255,0.7)', marginTop: 'var(--sp-4)', maxWidth: '56ch' }}>
            {t('vinhos.lead')}
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <p className="t-body-lg t-light t-center" style={{ padding: 'var(--sp-16) 0' }}>
              {t('common.loading')}
            </p>
          ) : error ? (
            <div className="t-center" style={{ padding: 'var(--sp-16) 0' }}>
              <p className="t-body-lg t-light">{t('common.error')}</p>
              <button type="button" className="btn btn-sm" style={{ marginTop: 'var(--sp-6)' }} onClick={refetch}>
                {t('common.retry')}
              </button>
            </div>
          ) : (
            <div className="grid-2" style={{ gap: 'var(--sp-8)' }}>
              {WINE_TYPES.map(type => {
                const count = wines.filter(w => w.type === type).length;
                const typeLabel = TYPE_KEYS[type] ? t(TYPE_KEYS[type]) : type;
                const typeDesc  = TYPE_DESC_KEYS[type] ? t(TYPE_DESC_KEYS[type]) : '';
                return (
                  <Link
                    key={type}
                    to={`/loja?tipo=${encodeURIComponent(type)}`}
                    className="vinhos-category-card"
                  >
                    <p className="t-label" style={{ color: '#000000' }}>
                      {count} {t('vinhos.references')}
                    </p>
                    <h2 className="t-h2" style={{ marginTop: 'var(--sp-3)' }}>{typeLabel}</h2>
                    <p className="t-body" style={{ color: 'rgba(0,0,0,0.6)', marginTop: 'var(--sp-3)' }}>
                      {typeDesc}
                    </p>
                    <span
                      className="t-label"
                      style={{ color: '#000000', marginTop: 'var(--sp-6)', display: 'inline-block' }}
                    >
                      {t('vinhos.viewInShop')}
                    </span>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
